
const state = {

    objPrizeSet:{  //添加阶梯奖励
        taskId:'',
        levelType:'',  //1，拉新奖励 2，订单奖励
        leftInclusiveInterval:'',   //左区间
        rightOpenInterval:'',        //右区间
        guiderTaskLevelPrizeDtos:[   //奖励列表
            {
                prizeObjTitle: '',      //奖励名称
                prizeObjType: '',       //奖励类型
                prizeObjValue: ''       //奖励内容
            }
        ],
    },


}

const getters = {
    getObjPrizeSet:state => state.objPrizeSet,
}

const mutations = {


}

const actions = {}









export default {
    state,
    mutations,
    actions,
    getters
};
